const LOADER_TYPE = {
  ACTION: 'action_loader',
  REFRESH: 'refresh_loader',
  LOAD_DATA: 'data_loader'
};

export default LOADER_TYPE;
